import API from "../../../utils/api";


export const getFitModelApi = async (filters) => {
    const response = await API.get(`settings/fit-model`, { params: filters });
    return { response };
};

export const addFitModelApi = async (data) => {
    const response = await API.post(`settings/fit-model`, data, { "content-type": "multipart/form-data" });
    return { response };
};

export const updateFitModelApi = async (data, id) => {
    const response = await API.post(`settings/fit-model/${id}`, data, { "content-type": "multipart/form-data" });
    return { response };
}

export const deleteFitModelApi = async (id) => {
    const response = await API.delete(`settings/fit-model/${id}`);
    return { response };
}
